import { useSubscription } from './useSubscription';

import type { CreditBalance, CreditPricing } from '../types/billing';

// ----------------------------------------------------------------------

export type UseCreditPacksReturn = {
  pricing: CreditPricing | null;
  balances: CreditBalance[];
  balanceFor: (feature: string) => CreditBalance | null;
  totalCreditsForFeature: (feature: string) => number;
  hasAnyCredits: boolean;

  isLoading: boolean;
  error: unknown;
};

// ----------------------------------------------------------------------

export function useCreditPacks(): UseCreditPacksReturn {
  const { creditBalances, creditPricing, isLoading, error } = useSubscription();

  return {
    pricing: creditPricing,
    balances: creditBalances,
    balanceFor: (feature) =>
      creditBalances.find((b) => b.feature === feature) ?? null,
    totalCreditsForFeature: (feature) =>
      creditBalances.find((b) => b.feature === feature)?.remaining ?? 0,
    hasAnyCredits: creditBalances.some((b) => b.remaining > 0),
    isLoading,
    error,
  };
}
